import { useLoadableRemoteConfig } from "@hackler/react-sdk";

export function useRemoteConfig(key: string): {
  isRemoteConfigLoaded: boolean;
  parsedParamterValue: any;
} {
  const { isLoading, remoteConfig } = useLoadableRemoteConfig();
  const parameterValue = remoteConfig.get(key, "defaultValue");
  const isRemoteConfigLoaded = !isLoading && parameterValue !== "defaultValue";
  const parsedParamterValue =
    isRemoteConfigLoaded && JSON.parse(parameterValue);
  return { isRemoteConfigLoaded, parsedParamterValue };
}
